<modal-container
  #modal
  [headerTitle]="exportType + '-create'"
  [headerIconClass]="'far-file-' + selectedExportFormat === 'pdf' ? 'pdf' : 'excel'"
>
  <ng-container class="modal-button-show">
    <btn
      [label]="'create'"
      [title]="'create' | translate"
      [icon]="'far-plus'"
      [classes]="['btn-first', 'float-right']"
      [isLoading]="loading"
      [spinnerClassesString]="'spinner-white'"
      (onEvent)="showChildModal()"
      [attr.data-cy]="dataCyAttribute"
    >
    </btn>
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="row">
        @if (exportType === 'stock-exports') {
          <div class="col-sm-6">
            <form-row-select
              [label]="'stateTypeToDate'"
              [icon]="null"
              [options]="stockExportDateTypes"
              [(model)]="stockExportDateType"
              [dataCyAttribute]="'date-from'"
            ></form-row-select>
          </div>
        }
        <div class="col-sm-{{ exportType !== 'inventory-exports' ? '6' : '12' }}">
          @if (exportType !== 'stock-exports' || (exportType === 'stock-exports' && stockExportDateType === 'date')) {
            <form-row-input
              [label]="exportType !== 'inventory-exports' && exportType !== 'stock-exports' ? 'date.from' : 'date'"
              [inputType]="'date'"
              [icon]="null"
              [(model)]="dateFrom"
              data-cy="date-from"
            ></form-row-input>
          }
        </div>
        @if (exportType !== 'inventory-exports' && exportType !== 'stock-exports') {
          <div class="col-sm-6">
            <form-row-input [label]="'date.to'" [inputType]="'date'" [icon]="null" [(model)]="dateTo"></form-row-input>
          </div>
        }
        @if (exportType === 'order-exports') {
          <div class="col-sm-6">
            <form-row-select
              [label]="'order.status'"
              [icon]="null"
              [options]="orderStatusTypes"
              [(model)]="selectedOrderStatus"
              [dataCyAttribute]="'export-order-status-select'"
            ></form-row-select>
          </div>
        }
        @if (exportType !== 'sale-exports' && exportType !== 'order-exports') {
          <div class="col-sm-6">
            <form-row-select-multiple
              [selectedValues]="selectedDepots"
              [label]="'reports.depots'"
              [options]="queryDepotsOptions.data()"
              (selectedValuesChange)="selectedDepots = $event; saveViewSettings()"
              [dataCyAttribute]="'depots'"
            ></form-row-select-multiple>
          </div>
        }
        @if (exportType !== 'inventory-exports' && exportType !== 'stock-exports') {
          <div class="col-sm-6">
            <form-row-select-multiple
              [selectedValues]="selectedCheckouts"
              [label]="'checkouts.select'"
              [options]="queryCheckouts.data()"
              (selectedValuesChange)="selectedCheckouts = $event; saveViewSettings()"
              [dataCyAttribute]="'checkouts'"
            ></form-row-select-multiple>
          </div>
        }
        @if (exportType !== 'order-exports') {
          <div class="col-sm-6">
            <form-row-select-multiple
              [selectedValues]="selectedSuppliers"
              [label]="'products.suppliers'"
              [options]="querySuppliers.data()"
              (selectedValuesChange)="selectedSuppliers = $event; saveViewSettings()"
              data-cy="suppliers"
            ></form-row-select-multiple>
          </div>
        }
        @if (exportType !== 'order-exports') {
          <div class="col-sm-6">
            <form-row-select-multiple
              [selectedValues]="selectedProducers"
              [label]="'brands'"
              [options]="queryProducers.data()"
              (selectedValuesChange)="selectedProducers = $event; saveViewSettings()"
              data-cy="producers"
            ></form-row-select-multiple>
          </div>
        }
        @if (exportType !== 'inventory-exports') {
          <div class="col-sm-6">
            <form-row-select
              [label]="'format.type'"
              [icon]="null"
              [options]="exportFormatTypes"
              [(model)]="selectedExportFormat"
              [dataCyAttribute]="'export-format-type-select'"
            ></form-row-select>
          </div>
        }
      </div>
    </div>
  </ng-container>
  <ng-container class="modal-footer-content">
    <btn
      [label]="'save'"
      [title]="'save' | translate"
      [icon]="selectedExportFormat === 'pdf' ? 'far-file-pdf' : 'far-file-excel'"
      [classes]="['btn-first']"
      [btnDisabled]="!dateFrom && exportType !== 'stock-exports'"
      [isLoading]="loading"
      (onEvent)="createPrintExport()"
      data-cy="added-inventory"
    ></btn>
  </ng-container>
</modal-container>
